import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { CountryService } from '../../http/country/country.service';

@Injectable({
  providedIn: 'root',
})
export class AdminCountryGuard
  implements CanActivate, CanActivateChild, CanLoad
{
  constructor(private countryService: CountryService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canVisit();
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canVisit();
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canVisit();
  }

  private canVisit(): Observable<boolean> {
    return this.countryService.getUserAdminCountries().pipe(
      switchMap((countries: string[]) => {
        let allow: boolean = false;
        allow = countries !== undefined && countries.length > 0;

        if (!allow) {
          this.router.navigate(['/forbidden']);
        }
        return of(allow);
      })
    );
  }
}
